<template>
  <div
    class="border border-gray-500 rounded p-3 flex flex-wrap text-xl outline-none focus:border-cardstock-green-500 focus:shadow scrollbar"
    tabindex="0"
    @keydown.up.prevent="shiftSelection(-1 * columns)"
    @keydown.down.prevent="shiftSelection(columns)"
    @keydown.left.prevent="shiftSelection(-1)"
    @keydown.right.prevent="shiftSelection(1)"
    ref="menu"
  >
    <div
      v-for="item in possibleItems"
      class="w-1/3 text-center rounded"
      :class="widthClass"
      @click="changeInputTo(item)"
      :key="item.id"
      ref="item"
    >
      <slot :item="item" :isSelected="isSelected(item)"></slot>
    </div>
  </div>
</template>

<script>
import _get     from 'lodash/get'
import _indexOf from 'lodash/indexOf'
import _nth     from 'lodash/nth'

export default {
  props: {
    possibleItems: { type: Array, required: false, default: () => [] },
    value: { default: null },
    columns: { type: Number, default: 5 }
  },

  computed: {
    widthClass() {
      return "w-1/" + this.columns
    }
  },

  methods: {
    changeInputTo: function (value) {
      if (this.value == value) {
        this.$emit('input', null)
      } else {
        this.$emit('input', value)
      }
    },

    changeToIndex: function (index) {
      var item = _nth(this.possibleItems, index)

      this.$emit('input', item)
      this.scrollToActiveItem(index)
    },

    isSelected: function(item) {
      return item.id == _get(this.value, 'id')
    },

    shiftSelection: function (change) {
      var newIndex  = _indexOf(this.possibleItems, this.value) + change
      var maxIndex  = this.possibleItems.length - 1

      if (newIndex < 0) {
        console.log("index less than zero")
        this.changeToIndex(0)
      } else if (newIndex > maxIndex) {
        console.log("index too big")
        this.changeToIndex(maxIndex)
      } else {
        console.log("index OK")
        this.changeToIndex(newIndex)
      }
    },

    scrollToActiveItem: function (index) {
      this.$refs.item[index].scrollIntoView(false)
    }
  }
}
</script>
